import { useContext } from "react";
import { AuthContext } from "../../../util/context";
import ViewRequisition from "../../requisition/view-requisition/ViewRequisition";
import Login from "../../auth/Login";
import Dashboard from "../../dashboard/Dashboard";

export default function ViewRequisitionPage() {
  let view;
  const { isAuthenticated, user, isUser } = useContext(AuthContext);

  const viewRequisition =
    user?.job_role?.toLowerCase() === "accountant" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "hop" ||
    user?.job_role?.toLowerCase().includes("hod") ||
    user?.job_role?.toLowerCase() === "seed" ||
    user?.job_role?.toLowerCase() === "hr";

  if (viewRequisition) {
    view = <ViewRequisition />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated && isUser ? view : <Login />}</>;
}
